import Text from '@tiptap/extension-text';
import { EditorContent, useEditor } from '@tiptap/react';
import * as React from 'react';
import { useEffect } from 'react';
import { ComputeExpression } from '../ComputeExpression';
import { ExpressionsEditorStyles } from '../input/ComputeExpressionBaseInput';
import { computeExpressionToJsonContent } from '../input/computeExpressionToJsonContent';
import { ComputeExpressionNode } from '../input/nodes/ComputeExpressionNode';
import { ComputeExpressionReferenceNode } from '../input/nodes/ComputeExpressionReferenceNode';
import { ComputeExpressionRootNode } from '../input/nodes/ComputeExpressionRootNode';

export interface IComputeExpressionPreviewProps {
  expression: ComputeExpression;
}

/**
 * Renderizza, tramite l'editor, un'anteprima dell'espressione di calcolo
 * in formato **non editabile**, a partire dal JSON registrato.
 */
export function ComputeExpressionPreview(
  props: IComputeExpressionPreviewProps,
) {
  const { expression } = props;

  const editor = useEditor({
    extensions: [
      // TODO Centralizzare in `input` in modo da poterli importare qui
      ComputeExpressionRootNode,
      ComputeExpressionNode,
      ComputeExpressionReferenceNode.configure({}),
      Text,
    ],
    editable: false,
    content: computeExpressionToJsonContent(expression),
    injectCSS: false,
    editorProps: {
      attributes: {
        // Per il rendering dell'anteprima
        class: 'rich-text-input-editor',
      },
    },
  });

  useEffect(() => {
    editor?.commands.setContent(computeExpressionToJsonContent(expression));
  }, [editor, expression]);

  return (
    <ExpressionsEditorStyles>
      <EditorContent editor={editor} />
    </ExpressionsEditorStyles>
  );
}
